import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnet = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 7V5C5 3.89543 5.89543 3 7 3C8.10457 3 9 3.89543 9 5V7M5 7H9M5 7V14C5 17.866 8.13401 21 12 21C15.866 21 19 17.866 19 14V7M9 7V14C9 15.6569 10.3431 17 12 17C13.6569 17 15 15.6569 15 14V7M15 7V5C15 3.89543 15.8954 3 17 3C18.1046 3 19 3.89543 19 5V7M15 7H19",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgMagnet;
